import { MotorcycleModel } from '../model/moto.model';
import { SUPPORTED_LANGUAGES, SupportedLanguages } from '../locales/i18n';
import motorcycles_en from '../data/en/motos.json';
import motorcycles_ro from '../data/ro/motos.json';
import i18next from '../locales/i18n';

export async function getMotorcycles(lang: SupportedLanguages): Promise<MotorcycleModel[]> {
    await fakeWaitingTime();
    return new Promise((resolve) => {
        if (!SUPPORTED_LANGUAGES.includes(lang)) {
            throw new Error(i18next.t('api:motorcycles.invalid-lang-param'));
        }

        const response = {
            'ro': motorcycles_ro,
            'en': motorcycles_en,
        }

        resolve(response[lang]['motorcycles']);
    });
}

export async function getMotorcycle(id: number, lang: SupportedLanguages): Promise<MotorcycleModel> {
    await fakeWaitingTime();
    return new Promise((resolve) => {
        if (!SUPPORTED_LANGUAGES.includes(lang)) {
            throw new Error(i18next.t('api:motorcycles.invalid-lang-param'));
        }

        const response = {
            'ro': motorcycles_ro,
            'en': motorcycles_en,
        }

        const motoExists = () => response[lang].motorcycles.some(x => x.id === id);
    
        if (!motoExists()) {
            throw new Error(i18next.t('api:motorcycles.moto-not-found', { motoId: id.toString() }));
        }

        resolve(response[lang]['motorcycles'][id]);
    });
}

async function fakeWaitingTime(): Promise<void> {
    if (process.env.NODE_ENV === 'development') {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve();
            }, (<number>(process.env.REACT_APP_REQUEST_WAITING_TIME as unknown)) * Math.random());
        });
    }
    return Promise.resolve();
}